import React, { useState } from 'react';

import { Box, Button, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import moment from 'moment';

export  function ActiveCprModal({ active, onClose, cpr }) {
  const [loadingForm, setLoadingForm] = useState(false);

  const checkDateSigned = moment.utc(cpr.date_signed).format("DD/MM/YYYY") !== moment.utc(new Date()).format("DD/MM/YYYY")

  const handleOnCloseModal = () => {
    onClose();
  };

  const handleSubmit = async () => {
    setLoadingForm(true);
    try {
      await active()
      setLoadingForm(false);
      handleOnCloseModal();
    } catch (error) {
      setLoadingForm(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          width: "100%",
          maxWidth: 700,
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: 24,
          borderRadius: 2,
          backgroundColor: grey[300],
        }}
      >
        <Box
          sx={{
            padding: "16px",
            borderRadius: "8px 8px 0 0",
            backgroundColor: "#fff",
          }}
        >
          <Typography variant="h6" component="h2">
            Confirme a ativação da CPRF
          </Typography>

          {checkDateSigned && (
            <Box sx={{ marginY: 2 }}>
              <Typography
                variant="h6"
                fontSize={14}
                color={"red"}
                component="h2"
              >
                A data de assinatura deve ser a mesma da ativação.
              </Typography>
              <Typography
                variant="h6"
                fontSize={14}
                color={"red"}
                component="h2"
              >
                Assinatura: {moment.utc(cpr.date_signed).format("DD/MM/YYYY")}
              </Typography>
            </Box>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            padding: 2,
            borderRadius: "0 0 8px 8px",
            backgroundColor: "#fff",
          }}
        >
          <Button
            variant="contained"
            color="error"
            onClick={() => handleOnCloseModal()}
          >
            <Typography color={"#fff"}>Cancelar</Typography>
          </Button>
          <Button
            variant="contained"
            disabled={checkDateSigned || loadingForm}
            color={"success"}
          >
            <Typography color={"#fff"} onClick={() => handleSubmit()}>
              Ativar CPRF
            </Typography>
          </Button>
        </Box>
      </Box>
    </>
  );
}
